module.exports = __webpack_public_path__ + "static/media/login-bg.04383ee4.jpg";